import RoomLaserEdit from './RoomLaserEdit.vue';
import RoomLaser from './RoomLaser.vue';
export { RoomLaserEdit };
export default RoomLaser;
